export const FETCH_LIST_CART_IN_LOCAL_STORAGE_SUCCESS =
  "FETCH_LIST_CART_IN_LOCAL_STORAGE_SUCCESS";

export const FETCH_LIST_CART_SUCCESS = "FETCH_LIST_CART_SUCCESS";
